// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__5x2cA","loader_spinner":"loader_loader_spinner__HTuzd","spin":"loader_spin__1-Dpg"};